import React from "react";
import { T } from "../traks";
import { Col, Row } from "reactstrap";

export const CapitalSection = ({ NoEdit, initial_bankroll_defaults, this_parent, RadiosAndCustom, state_invalid_input }) => {
    return (
        <React.Fragment>
            
                <Row className="justify-content-center">
                    <Col md="12" className="px-md-4 pt-4 pb-4">
                        <img alt="" className="ad_logo_list" src="/gfx/bankroll-icon-color-0.svg"/><span className="ad_120_bold pl-2"><T>Bankroll</T></span>
                        <p>
                        <small><T>How much money each player will get to begin with. This setting cannot be changed after game start</T></small><br/>
                        </p>
                        <NoEdit>
                        <T><RadiosAndCustom
                            name="bankroll"
                            parent={this_parent}
                            defaults={initial_bankroll_defaults}
                            custom_text="Other"
                            custom_placeholder="Amount"
                            custom_error={state_invalid_input === "bankroll"}
                            min={1}
                            max={10000000}
                        /></T>
                        </NoEdit>
                    </Col>
                </Row>
            
        </React.Fragment>
    )
}


// WEBPACK FOOTER //
// ./src/c/CapitalSection.js